var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_267)",
    id: "facebook-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6666 12.0002C23.6666 5.56016 18.4399 0.333496 11.9999 0.333496C5.55992 0.333496 0.333252 5.56016 0.333252 12.0002C0.333252 17.6468 4.34659 22.3485 9.66659 23.4335V15.5002H7.33325V12.0002H9.66659V9.0835C9.66659 6.83183 11.4983 5.00016 13.7499 5.00016H16.6666V8.50016H14.3333C13.6916 8.50016 13.1666 9.02516 13.1666 9.66683V12.0002H16.6666V15.5002H13.1666V23.6085C19.0583 23.0252 23.6666 18.0552 23.6666 12.0002Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "inherit"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.7527cc6b91278e547888ee395cc8095b.svg";
export { ForwardRef as ReactComponent };